import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/admindashboard.css";
class AdminDashboard extends Component {
  componentDidMount() {
  const token = localStorage.getItem("adminToken");

if (!token) {
      this.props.navigate("/admin", { replace: true });
    }
  }

  logout = () => {
    localStorage.removeItem("adminToken");
    this.props.navigate("/admin", { replace: true });
  };

  render() {
    return (
      <div>
        <div className="admin-dashboard-container">

          <h1 className="admin-dashboard-title">🛠️ Admin Dashboard</h1>

          <div className="admin-dashboard-grid">

            <button onClick={() => this.props.navigate("/admin-users")} className="admin-btn">👥 Users</button>

            <button onClick={() => this.props.navigate("/admin-matches")} className="admin-btn"> 🎮 Matches </button>

            <button onClick={() => this.props.navigate("/admin-revenue")} className="admin-btn" >💰 Revenue</button>

            <button onClick={() => this.props.navigate("/admin-deposits")} className="admin-btn">Deposits</button>

            <button onClick={() => this.props.navigate("/admin-withdraws")} className="admin-btn" > 💸 Withdraws </button>

          </div>

          <button onClick={this.logout} className="logout-btn"> Logout </button>

        </div>

      </div>
    );
  }
};

export default withNavigation(AdminDashboard);